<template>
  <div class="dashboard px-4">
    <div class="float-right my-4 daily-result d-flex align-center">
      <span class="mr-2 value-descr">Br. pregleda</span
      ><span class="value">{{ countToday }}</span>
    </div>
    <h2 class="main-title">
      {{ lang == "en" ? "Dashboard" : "Početna strana" }}
    </h2>
    <div class="main-container">
      <v-row class="filterBtnContainer">
        <v-col class="d-flex justify-end">
          <v-btn
            depressed
            class="text--white gray darken-2"
            @click="showFilterMobile = !showFilterMobile"
          >
          Filteri
          <v-icon
            right
            dark
          >
            {{showFilterMobile ? 'mdi-menu-up' : 'mdi-menu-down'}}
          </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="main-filters" :class="{showFilterMobile: showFilterMobile}">
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            :label="lang == 'en' ? 'Owner name' : 'Ime Vlasnika'"
            v-model="searchForm.name"
            @keyup.enter="getUsers(true)"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            :label="lang == 'en' ? 'Owner surname' : 'Prezime Vlasnika'"
            v-model="searchForm.surname"
            @keyup.enter="getUsers(true)"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            label="Mail"
            @keyup.enter="getUsers(true)"
            v-model="searchForm.mail"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            :label="lang == 'en' ? 'Phone number' : 'Broj Tel.'"
            @keyup.enter="getUsers(true)"
            v-model="searchForm.phone"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            :label="lang == 'en' ? 'Pet ID' : 'Čip ID'"
            @keyup.enter="getUsers(true)"
            v-model="searchForm.chip"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2" class="filter-btns">
          <v-btn
            depressed
            class="text--white teal darken-2"
            @click="getUsers(true)"
          >
            <v-icon> mdi-account-search </v-icon>
          </v-btn>
          <v-btn depressed text class="white--text clearBtn" @click="reset()">
            <v-icon left> mdi-close </v-icon>
            {{ lang == "en" ? "RESET" : "OBRIŠI" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="ownersResults.length">
        <v-col cols="12">
          <div
            :class="{ odd: ownerIndex % 2 != 0 }"
            class="tableOwner justify-space-between flex-wrap"
            v-for="(owner, ownerIndex) in ownersResults"
            :key="ownerIndex"
          >
            <div class="tableCell-small d-flex align-center">
              <v-btn
                small
                class="mx-1 teal white--text"
                :to="'/ManageOwner?id=' + owner.ownerId"
                ><v-icon>mdi-account-edit-outline</v-icon></v-btn
              >
            </div>
            <div class="tableCell">
              <p>Vlasnik</p>
              <p class="orange--text">{{ owner.name + " " + owner.surname }}</p>
            </div>
            <div class="tableCell">
              <p>Email</p>
              <p>{{ owner.email }}</p>
            </div>
            <div class="tableCell">
              <p>Adresa</p>
              <p>{{ owner.address }}</p>
            </div>
            <div class="tableCell">
              <p>Mobilni tel.</p>
              <p>{{ owner.mobilePhone }}</p>
            </div>
            <div class="d-flex align-center justify-end tableCell">
              <v-btn
                small
                class="mx-1 cyan accent-1"
                :to="'/ManagePet/?idOwner=' + owner.ownerId"
              >
                <v-icon left>mdi-plus</v-icon>
                <v-icon right dark> mdi-dog</v-icon>
              </v-btn>
              <v-btn
                small
                v-if="owner.pets && owner.pets.length"
                class="mx-1"
                @click="showPets(owner)"
              >
                <v-icon dark color="teal">
                  {{ owner.pets.length }}
                </v-icon>
                <v-icon color="teal" v-if="!owner.ownerShowPets" right
                  >mdi-menu-down</v-icon
                >
                <v-icon color="teal" v-if="owner.ownerShowPets" right
                  >mdi-menu-up</v-icon
                >
              </v-btn>
            </div>
            <div class="tableRow" v-if="owner.ownerShowPets">
              <v-tabs :class="{ odd: ownerIndex % 2 != 0 }">
                <v-tab
                  class="teal darken-4 lighten-4--text tabName"
                  v-for="(pet, indexPet) in owner.pets"
                  :key="indexPet"
                >
                  {{ pet.name }}
                </v-tab>

                <v-tab-item
                  v-for="(pet, indexPet) in owner.pets"
                  :key="indexPet"
                  class="px-1 py-0"
                >
                  <div class="d-flex pet-info">
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-btn
                            small
                            class="mx-1"
                            style="max-width: 50px;"
                            :to="'/ManagePet?id=' + pet.petId"
                          >
                            <v-icon dark> mdi-circle-edit-outline </v-icon>
                          </v-btn>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-subtitle>Vrsta</v-list-item-subtitle>
                          <v-list-item-title>{{ pet.type }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-subtitle>Rasa</v-list-item-subtitle>
                          <v-list-item-title>{{ pet.breed }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-subtitle>Pol</v-list-item-subtitle>
                          <v-list-item-title>{{
                            pet.gender
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-subtitle>ID cipa</v-list-item-subtitle>
                          <v-list-item-title>{{
                            pet.microChipNo
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Broj pasoša</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            pet.passportNo
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Datum rodjenja</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            pet.dateOfBirth
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex justify-end align-center">
                      <v-btn
                        small
                        class="mx-1"
                        :to="'/Examination/?petId=' + pet.petId"
                      >
                        <v-icon left> mdi-plus </v-icon>
                        Pregled
                      </v-btn>
                      <v-btn
                        small
                        class="mx-1 orange darken-4 white--text"
                        @click="openTimeline(pet)"
                        ><v-icon left>mdi-file-document-outline</v-icon
                        >Istorija</v-btn
                      >
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs>
            </div>
          </div>
        </v-col>
        <v-pagination
          class="justify-end"
          color="teal darken-3"
          v-model="pagination.page"
          :length="Math.ceil(totalOwnerResult / pageSize)"
          @input="getUsers(false)"
        ></v-pagination>
      </v-row>
      <v-row v-else>
        <v-col>
          <v-col>
            <v-alert
              class="py-4"
              text
              dense
              color="teal"
              icon="mdi-information-outline"
              border="left"
            >
              <h4>Nema rezultata pretrage</h4>
            </v-alert>
          </v-col>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Dashboard",
  data() {
    return {
      showFilterMobile: false,
      pagination: {
        page: 1
      }
    };
  },
  components: {
  },
  computed: {
    ...mapState([
      "searchForm",
      "lang",
      "ownersResults",
      "IDcompany",
      "countToday",
      "totalOwnerResult",
      "pageSize"
    ]),
  },
  mounted() {
    this.getUsers();
    this.$store.dispatch("getCountToday");
  },
  methods: {
    getUsers(resetPage) {
      if (resetPage) {
        this.pagination.page = 1
      }
      var payload = {
        name: this.searchForm.name,
        surname: this.searchForm.surname,
        email: this.searchForm.mail,
        mobile: this.searchForm.phone,
        microChipNo: this.searchForm.chip,
        companyId: this.IDcompany,
        page: this.pagination.page,
        pageSize: this.pageSize
      };
      this.$store.dispatch("getOwners", payload).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
      this.showFilterMobile = false
    },
    reset() {
      this.$store.commit("resetSearchForm");
    },
    showPets(owner) {
      owner.ownerShowPets = !owner.ownerShowPets;
    },
    editPet(pet) {
      alert(pet);
    },
    openTimeline(pet) {
      this.$router.push("/timeline/?petId=" + pet.petId);
    },
  },
};
</script>

<style lang="scss">
.clearBtn {
  margin-left: 15px;
}
.dashboard {
  .v-text-field__details {
    display: none;
  }
}
.v-tabs--vertical > .v-tabs-bar .v-tab {
  height: 64px !important;
}
.v-tabs-slider-wrapper {
  height: 5px !important;
}
.v-application .teal.darken-4.v-tab {
  background-color: #036353 !important;
}
.v-application .teal.darken-4.v-tab--active {
  background-color: #0fb99d !important;
}
.odd {
  background: #141414;
}
.even {
  background: transparent;
}
.tableOwner {
  display: flex;
  border-bottom: 1px solid grey;
  padding-top: 5px;
}
.theme--light.v-tabs-items {
  background: transparent !important;
}
.v-application {
  .tableRow {
    flex: 0 0 100%;
    background: #232323;
    margin: 10px 0 0 0;
    .tabName {
      font-size: 12px;
    }
    .v-slide-group__content {
      caret-color: #fff !important;
      color: #fff !important;
      background: #232323;
    }
    .v-window-item {
      background: #232323;
      color: #adadad;
    }
    .odd {
      .v-slide-group__content {
        background: #141414;
      }
      .v-window-item {
        color: red;
      }
      .v-window-item {
        background: #141414;
      }
      .v-tabs-items {
        background: #141414;
      }
    }
    .pet-info {
      display: flex;
      p {
        margin-bottom: 0;
      }
    }
    .v-list-item__subtitle {
      color: gainsboro;
    }
    .v-list-item__title {
      color: #adadad;
    }
  }
}
.daily-result {
  user-select: none;
  background: #00bfa5;
  padding: 10px 15px;
  border-radius: 4px;
  p {
    margin-bottom: 0;
  }
  span {
    font-size: 12px;
    color: #fff;
  }
  .value {
    font-size: 18px;
  }
}
.tableCell {
  flex: 0 0 18%;
  p {
    margin-bottom: 0;
  }
  p:nth-child(1) {
    font-size: 12px;
  }
}
.filterBtnContainer {
  display: none!important;
}
.main-filters {
  display: flex!important;
}

@media (max-width: 1060px) {
  .v-application {
    .tableRow {
      .pet-info {
        flex-wrap: wrap;
        > div {
          flex: 0 0 33.33%;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .filter-btns {
    > .v-btn {
      flex: 0 0 100%;
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .clearBtn {
    margin-left: 0;
  }
  .main-filters {
    display: none!important;
  }
  .main-filters.showFilterMobile {
    display: flex!important;
  }
  .filterBtnContainer {
    display: block!important;
  }
  .value-descr {
    display: none;
  }
  .daily-result {
    padding: 5px 10px;
  }
  .tableCell-small {
    flex: 0 0 100%;
    margin-bottom: 10px;
    margin-left: -4px;
  }
  .tableCell {
    flex: 0 0 50%;
    margin-bottom: 10px;
  }
  .tableCell:last-child {
    flex: 0 0 100%;
  }
  .tableCell:nth-child(2) {
    flex: 0 0 100%;
  }
  .tableOwner {
    padding: 7px;
  }
  .v-application {
    .tableRow {
      .pet-info {
        padding: 10px 0;
      }
    }
  }
}

@media (max-width: 600px) {
  .v-application {
    .tableRow {
      .pet-info {
        justify-content: flex-end;
        flex-wrap: wrap;
        > div {
          flex: 0 0 50%;
        }
        > div:last-child {
          justify-content: end;
        }
      }
    }
  }
}
</style>